(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["new-header"]) return;
  try {
    
  $(document).ready(function(){
      $('.top_main_navigation').each(function(){
          if($(this).find('li.child_active_navigation').length !== 0){
              $(this).addClass("current_active_navigation");
          }
      });

    
  });

  //document.addEventListener('DOMContentLoaded', function () {

//   // Handle submenus inside Bootstrap dropdowns
//   document.querySelectorAll('.dropdown-menu .dropdown-toggle').forEach(function (dropdownToggle) {
//   dropdownToggle.addEventListener('click', function (e) {
//     const submenu = this.nextElementSibling;
 
//     // ✅ Only prevent default if a submenu exists
//     if (submenu && submenu.classList.contains('dropdown-menu') && submenu.children.length > 0) {

//       e.preventDefault();
//       e.stopPropagation();
 
//       // Close other open submenus
//       const parentMenu = this.closest('.dropdown-menu');
//       if (parentMenu) {
//         parentMenu.querySelectorAll('.show').forEach(function (openMenu) {
//           if (openMenu !== submenu) {
//             openMenu.classList.remove('show');
//           }
//         });
//       }
 
//       // Toggle this submenu
//       submenu.classList.toggle('show');
//     }
//     // ✅ If no submenu exists, normal behavior (redirect) happens
//   });
// });

  // Close submenu when clicking outside
//   document.addEventListener('click', function () {
//     document.querySelectorAll('.dropdown-menu .show').forEach(function (submenu) {
//       submenu.classList.remove('show');
//     });
//   });

// });


// document.querySelectorAll('.dropdown-submenu .dropdown-submenu-item-arrow').forEach(function (toggle) {

//   toggle.addEventListener('click', function (e) {

//     e.preventDefault();
//     e.stopPropagation();
 
//     const currentItem = this.parentElement;
//     // ✅ Reset rotate class for all submenu arrows except current one
//       document.querySelectorAll('.dropdown-submenu > a.rotate').forEach(function (arrow) {
//         if (arrow !== toggle) {
//           arrow.classList.remove('rotate');
//         }
//       });
//     // ✅ Close any other open submenu & reset their arrow
//     document.querySelectorAll('.dropdown-submenu.show').forEach(function(item) {
//       if (item !== currentItem) {
//         item.classList.remove('show');
//         item.querySelector(':scope > a').classList.remove('rotate');
//       }
//     });
 
//     // ✅ Toggle current submenu
//     currentItem.classList.toggle('show');
 
//     // ✅ Toggle arrow rotation only on current item
//     this.classList.toggle('rotate');
//   });
// });

  } catch(e) { console.error(e); }
})();
})();
